import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatAccordion } from '@angular/material/expansion';

import { FacadeComponentAvailability } from 'cloud-shared-lib';
import { FacadeView } from '../../models/cutting/facade-view.model';
import { CuttingSettings } from '../../models/user/cutting-settings.model';
import { FacadeSettingsStateService } from './facade-settings-state.service';
import { SizesComponent } from './sizes/sizes.component';

export class FacadeSettingsBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _FacadeSettingsMixinBase = mixinDisabled(FacadeSettingsBase);

@Component({
  selector: 'csl-facade-settings',
  templateUrl: './facade-settings.component.html',
  viewProviders: [FacadeSettingsStateService],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class FacadeSettingsComponent extends _FacadeSettingsMixinBase implements OnChanges, CanDisable {
  @Input({ required: true }) panel: FacadeView;
  @Input({ required: true }) userId: number;
  @Input() currencySymbol = '';
  @Input({ required: true }) cuttingSettings: CuttingSettings;
  @Input() componentsAvailability?: FacadeComponentAvailability;

  validPanelForm = false;

  @ViewChild('accordion', { static: true }) Accordion: MatAccordion;
  @ViewChild(SizesComponent) sizes: SizesComponent;

  get isMaterialSelected(): boolean {
    return !!this.panel.material;
  }

  get showMilling(): boolean {
    return !this.panel.material || this.panel.material.milling;
  }

  get valid(): boolean {
    return this.sizes.valid;
  }

  get showEdge(): boolean {
    return !this.componentsAvailability || this.componentsAvailability.edge;
  }

  get showFasteners(): boolean {
    return !this.componentsAvailability || this.componentsAvailability.fasteners;
  }

  get showAngleProcessing(): boolean {
    return !this.componentsAvailability || this.componentsAvailability.angleProcessing;
  }

  get showSlots(): boolean {
    return !this.componentsAvailability || this.componentsAvailability.slots;
  }

  get showHandles(): boolean {
    return !this.componentsAvailability || this.componentsAvailability.handles;
  }

  constructor(private facadeSettingsService: FacadeSettingsStateService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.userId?.currentValue) {
      this.facadeSettingsService.userId = +changes.userId.currentValue;
    }

    if (changes?.panel?.currentValue) {
      this.facadeSettingsService.updatePanel(changes.panel.currentValue);
    }
  }

  validPanelSize(value: boolean): void {
    if (!value) {
      this.Accordion.closeAll();
    }

    this.validPanelForm = value;
  }
}
